import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["End", "endSlot", "Inner", "Middle", "middleSlot", "Start", "startSlot", "__distributeEvenly", "responsive"];
import { Flex } from '../../../components/Flex';
import { SlotFlex } from './SlotFlex';
import { InnerFlex } from './InnerFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AbstractToolbar = _ref => {
  let {
      End,
      endSlot,
      Inner,
      Middle,
      middleSlot,
      Start,
      startSlot,
      __distributeEvenly,
      responsive
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const InnerComponent = Inner || InnerFlex;
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    role: "group",
    flexDirection: "row",
    marginBlock: "300"
  }, rest, {
    children: /*#__PURE__*/_jsxs(InnerComponent, {
      responsive: responsive,
      $justifyEnd: !!endSlot && !startSlot && !middleSlot,
      children: [startSlot && (Start ? /*#__PURE__*/_jsx(Start, {
        __distributeEvenly: __distributeEvenly,
        children: startSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "start",
        children: startSlot
      })), middleSlot && (Middle ? /*#__PURE__*/_jsx(Middle, {
        __distributeEvenly: __distributeEvenly,
        children: middleSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "middle",
        children: middleSlot
      })), endSlot && (End ? /*#__PURE__*/_jsx(End, {
        __distributeEvenly: __distributeEvenly,
        children: endSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "end",
        children: endSlot
      }))]
    })
  }));
};
AbstractToolbar.displayName = 'AbstractToolbar';